// src/pages/Dashboard/DashboardStyles.ts
import { Box, TextField, styled } from "@mui/material";

export const SearchToken = styled(TextField)`
  align-self: stretch;
  flex: 1;
  & .MuiOutlinedInput-root {
    border-radius: 8px;
    border: 1px solid #9993;
    // box-shadow: 0px 6px 8px 2px #9996 inset, 0px -4px 8px 0px #9991 inset, 0 0 10px #0008;
    font-size: 1em;
    backdrop-filter: blur(10px);

    &:hover {
      border-color: #AAA;
      box-shadow: 0px 4px 4px 2px rgba(6, 182, 212, 0.2) inset, 0px -4px 8px 0px rgba(6, 182, 212, 0.1) inset, 0 0 10px #0008;
    }

    & fieldset {
      border-color: transparent !important;
    }
  }
`;

export const LetsGo = styled(Box)`
  position: relative;
  overflow: hidden;
  text-decoration: none;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    width: 200%;
    bottom: -33px;
    border: 2px solid #fce69c;
    height: 36px;
    border-radius: 100%;
    transform: rotate(5deg);
  }
  p {
    z-index: 1;
    position: relative;
    background-image: linear-gradient(90deg, #FF8E08 0.14%, #FDFFB3 11.87%, #FFED4C 23.15%, #FBE4A8 54.37%, #F8D185 74.22%, #E66606 79.32%, #FCF3A0 86.96%, #FF7629 100%);
    background-clip: text;
    text-fill-color: transparent;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const OrderGroup = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding: 10px 20px;
  border-radius: 16px;
  background: #110B28;
  z-index: 1;

  & label, & .MuiSelect-select {
    font-size: 12px;
  }

  & label {
    line-height: 12px;
  }

  & .MuiInput-root:before, & .MuiInput-root:after {
    display: none;
  }

  & .MuiInput-input {
    padding-top: 0;
    padding-bottom: 0;
  }

  & .MuiInput-input:focus {
    background: none;
  }
`;

export const GradientBorder = styled(Box)`
  background: linear-gradient(90deg, #FF8E08 0.14%, #FDFFB3 11.87%, #FFED4C 23.15%, #FBE4A8 54.37%, #F8D185 74.22%, #E66606 79.32%, #FCF3A0 86.96%, #FF7629 100%);
  padding: 1px;
`

export const OrderBoxRoot = styled(Box)`
  width: fit-content;
  & > label {
    padding: 8px 16px;
    height: 100%;
    background: #232325;
    border-radius: 16px;
    color: white;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
  position: relative;
  & .overlay {
    position: fixed;
    top:0; left:0; right:0; bottom:0;
    z-index: 3;
  }
  & .menu {
    position: absolute;
    top:calc(100% + 6px); right:0;
    border-radius: 10px;
    min-width: calc(100% - 2px);
    box-sizing: border-box;
    z-index: 3;
  }
  & ul {
    background: #232325;
    list-style: none;
    padding: 0.4em 0;
    margin: 0;
    border-radius: 4px;
    color: #222;
    font-family: Inter;
    font-size: 14px;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #ddd;
      cursor: pointer;
      padding: 0.4em 1em;
      &.active {
        color: white;
        font-weight: bold;
      }
      &:hover {
        color: black;
        background: #ddd;
      }
      
    }
  }
  ${({ theme }) => theme.breakpoints.down("sm")} {
    & > label {
      padding: 12px 16px;
    }
  }
    
  ${({ theme }) => theme.breakpoints.down(800)} {
    width: 100%;
    & > label {
      border-radius: 4px;
    }
  }
`

export const CardGrid = styled(Box) <{ min: number, fill?: boolean, space: number }>`
  display: grid;
  width: 100%;
  align-items: stretch;
  // grid-auto-flow: row dense;
  grid-template-columns: repeat(auto-fill, minmax(${({ min }) => min}px, 1fr));
  gap: 16px ${({ space }) => space}px;

  ${({ theme }) => theme.breakpoints.down(400)} {
    grid-template-columns: 1fr;
  }
`;
